"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = require("../message/Message");
const react_1 = __importDefault(require("react"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const RedeemSectionLoginRequired = () => {
    const logoutLink = `${window_or_global_1.default.appContext || ''}/logout?state=${window_or_global_1.default.location.pathname}`;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "psnWarning" }, Message_1.localizedMessage('errors.com.epicgames.posa.psn.login.required')),
        react_1.default.createElement("a", { className: "psnWarning psn-sign-out", href: logoutLink }, Message_1.localizedMessage('epic.code.redemption.common.logout'))));
};
exports.default = RedeemSectionLoginRequired;
//# sourceMappingURL=RedeemSectionLoginRequired.js.map